<template>
  <header id="header" class="header-3">
    <!--header starts -->
    <div class="container">
      <div class="head-wrapp">
        <a href="javascript:" v-on:click="toHome" id="logo"><img src="static/images/logo.png" alt=""/><span>  </span></a>
        <!--your logo-->
        <ul class="main-menu alternative">
          <li><a href="javascript:" :id="HeaderCheck.tip1" v-on:click="toHome">{{$t('heardNavigation.home')}}</a>
            <!-- Second Level / Start -->
<!--            <ul>-->
<!--              <li><a href="index.html">Layer Slider (Default)</a></li>-->
<!--              <li><a href="home-revolution-slider.html">Revolution Slider</a></li>-->
<!--              <li><a href="home-flex-slider.html">Flex Slider</a></li>-->
<!--              <li><a href="home-alternative-header-1.html">Header Style 1</a></li>-->
<!--              <li><a href="home-alternative-header-2.html">Header Style 2</a></li>-->
<!--              <li><a href="home-alternative-header-3.html">Header Style 3</a></li>-->
<!--              <li><a href="#">Menu Second Level</a>-->
<!--                <ul>-->
<!--                  <li><a href="#">Dummy Item</a></li>-->
<!--                  <li><a href="#">Dummy Item</a></li>-->
<!--                </ul>-->
<!--              </li>-->
<!--            </ul>-->
            <!-- Second Level / End -->
          </li>
          <li><a href="javascript:" :id="HeaderCheck.tip2" v-on:click="toDevType">{{$t('heardNavigation.developmentType')}}</a>
            <!-- Mega Menu / Start -->
<!--            <ul class="four-columns">-->
<!--              <li class="one">-->
<!--                <h5>Some Pages</h5>-->
<!--                <ol>-->
<!--                  <li><a href="about-us.html"><i class="icon-group"></i>About Us</a></li>-->
<!--                  <li><a href="services.html"><i class="icon-cog"></i>Services</a></li>-->
<!--                  <li><a href="faq.html"><i class="icon-question-sign"></i>F.A.Q</a></li>-->
<!--                  <li><a href="team-member.html"><i class="icon-user"></i>Team Member</a></li>-->
<!--                </ol>-->
<!--              </li>-->
<!--              <li class="one">-->
<!--                <h5>Feature Pages</h5>-->
<!--                <ol>-->
<!--                  <li><a href="left-sidebar.html"><i class="icon-circle-arrow-left"></i>Left Sidebar</a></li>-->
<!--                  <li><a href="right-sidebar.html"><i class="icon-circle-arrow-right"></i>Right Sidebar</a></li>-->
<!--                  <li><a href="404-error.html"><i class="icon-warning-sign"></i>404 Page</a></li>-->
<!--                  <li><a href="clients.html"><i class="icon-quote-left"></i>Clients</a></li>-->
<!--                </ol>-->
<!--              </li>-->
<!--              <li class="one">-->
<!--                <h5>Elements Pages</h5>-->
<!--                <ol>-->
<!--                  <li><a href="elements.html"><i class=" icon-cogs"></i>Elements</a></li>-->
<!--                  <li><a href="icons.html"><i class="icon-th-large"></i>Icons</a></li>-->
<!--                  <li><a href="pricing-tables.html"><i class=" icon-table"></i>Pricing Tables</a></li>-->
<!--                  <li><a href="typography.html"><i class="icon-text-height"></i>Typography</a></li>-->
<!--                </ol>-->
<!--              </li>-->
<!--              <li class="one">-->
<!--                <h5>Portfolio Pages</h5>-->
<!--                <ol>-->
<!--                  <li><a href="portfolio-2.html"><i class=" icon-lightbulb"></i>2 Columns Portfolio</a></li>-->
<!--                  <li><a href="portfolio-3.html"><i class=" icon-suitcase"></i>3 Columns Portfolio</a></li>-->
<!--                  <li><a href="portfolio-4.html"><i class="icon-heart"></i>4 Columns Portfolio</a></li>-->
<!--                  <li><a href="single-project-small.html"><i class="icon-zoom-in"></i>Single Project</a></li>-->
<!--                </ol>-->
<!--              </li>-->
<!--            </ul>-->
            <!-- Mega Menu / End -->
          </li>
          <li><a href="javascript:" :id="HeaderCheck.tip3" v-on:click="toProductDisplay">{{$t('heardNavigation.productDisplay')}}</a>
            <!-- Second Level / Start -->
<!--            <ul>-->
<!--              <li><a href="portfolio-2.html">2 Columns Portfolio</a></li>-->
<!--              <li><a href="portfolio-3.html">3 Columns Portfolio</a></li>-->
<!--              <li><a href="portfolio-4.html">4 Columns Portfolio</a></li>-->
<!--              <li><a href="single-project-small.html">Single Project Small</a></li>-->
<!--              <li><a href="single-project-large.html">Single Project Large</a></li>-->
<!--            </ul>-->
            <!-- Second Level / End -->
          </li>
          <li><a href="javascript:" :id="HeaderCheck.tip4" v-on:click="toAbout">{{$t('heardNavigation.about')}}</a>
            <!-- Second Level / Start -->
<!--            <ul>-->
<!--              <li><a href="columns.html">Columns</a></li>-->
<!--              <li><a href="typography.html">Typography</a></li>-->
<!--              <li><a href="elements.html">Elements</a></li>-->
<!--              <li><a href="icons.html">Icons</a></li>-->
<!--              <li><a href="pricing-tables.html">Pricing Tables</a></li>-->
<!--            </ul>-->
            <!-- Second Level / End -->
          </li>
          <li><a href="javascript:" :id="HeaderCheck.tip5" v-on:click="toContact">{{$t('heardNavigation.contact')}}</a>
            <!-- Second Level / Start -->
<!--            <ul>-->
<!--              <li><a href="shop-layout.html">Shop</a></li>-->
<!--            </ul>-->
            <!-- Second Level / End -->
          </li>
          <li>
            <a href="javascript:" v-on:click="changeLang">{{$t('heardNavigation.changeLang')}}</a>
          </li>
        </ul>
        <!-- main navigation ends-->
        <!--search ends -->
      </div>
    </div>
    <!--main navigation wrapper ends -->
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: ['HeaderCheck'],
  inject: ['reload'],
  methods: {
    changeLang () {
      var lang = this.$i18n.locale
      if (lang === 'zh') {
        localStorage.setItem('lang', 'en')
        this.$i18n.locale = 'en'
      } else {
        localStorage.setItem('lang', 'zh')
        this.$i18n.locale = 'zh'
      }
    },
    toHome () {
      const router = this.$router
      // this.reload()
      // router.go(0)
      router.push({ name: 'Home' })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    },
    toDevType () {
    },
    toProductDisplay () {
      const router = this.$router
      // this.reload()
      // router.go(0)
      router.push({ name: 'product', params: {name: 'xiaoyan'} })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    },
    toAbout () {
      const router = this.$router
      // this.reload()
      // router.go(0)
      router.push({ name: 'aboutTeam' })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    },
    toContact () {
      const router = this.$router
      // this.reload()
      // router.go(0)
      router.push({ name: 'contact' })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="css" scoped>
  .container{
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue